import { USER_STATUSES } from "utils/helpers/enums/shared.enum";

export class PolicyFilterDTO {
  page: number = 1;
  limit: number = 30;
  count: number = 1;
  size: number = 30;
  heading: string = "";
}
